import Team, {TeamInput} from './Team';
import {TeamMemberRole} from './TeamMember';

export default class ViewerTeam extends Team {
    role: TeamMemberRole;
    constructor(data: TeamInput & {role: TeamMemberRole}) {
        super(data);
        this.role = data.role;
    }
}
